export const HOME_FEED_BOOTSTRAP_SCRIPT_ID = 'astrantis-home-feed-bootstrap';
const HOME_FEED_BOOTSTRAP_MAX_AGE_MS = 5 * 60_000;

/** Edge가 초기 HTML에 넣은 공개 홈 피드 snapshot을 읽는다. 개인화 데이터는 포함하지 않는다. */
export function readHomeFeedBootstrap(
  documentRef = typeof document === 'undefined' ? null : document,
  now = Date.now,
) {
  const element = documentRef?.getElementById(HOME_FEED_BOOTSTRAP_SCRIPT_ID);
  if (!element) return null;

  try {
    const snapshot = JSON.parse(element.textContent || '');
    if (
      snapshot?.version !== 1
      || !Number.isFinite(snapshot.storedAt)
      || !snapshot.data
      || !Array.isArray(snapshot.data.posts)
      || snapshot.data.posts.length > 50
      || Math.max(0, now() - snapshot.storedAt) > HOME_FEED_BOOTSTRAP_MAX_AGE_MS
    ) {
      return null;
    }
    return snapshot;
  } catch {
    return null;
  }
}
